import Lottie from "lottie-react";
import flowAnimation from "@/assets/ai-blob-flow.json";
import { useRef, useEffect } from "react";

interface AIBlobProps {
  isSpeaking: boolean;
  size?: number;
  className?: string;
  onClick?: () => void;
  onHover?: () => void;
}

export function AIBlob({
  isSpeaking,
  size = 140,
  className = "",
  onClick,
  onHover,
}: AIBlobProps) {
  const lottieRef = useRef<any>(null);

  useEffect(() => {
    if (!lottieRef.current) return;
    lottieRef.current.play();
    lottieRef.current.setSpeed(isSpeaking ? 1 : 0.25);
  }, [isSpeaking]);

  return (
    <div
      className={`flex items-center justify-center ${onClick ? "cursor-pointer" : ""} ${className}`}
      style={{ width: size, height: size }}
      onClick={onClick}
      onMouseEnter={onHover}
    >
      <Lottie
        lottieRef={lottieRef}
        animationData={flowAnimation}
        loop={true}
        autoplay={true}
        rendererSettings={{
          preserveAspectRatio: "xMidYMid slice",
        }}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}
